import React from 'react';
import { Icon } from 'js/components/common/Icon';
import Image from 'js/components/common/Image';

import { TRU_NARRATIVE_VERIFICATION_STATUS } from '../../constants';

import style from './StatusIcon.scss';

export const StatusIcon = ({ verificationStatus }) => {
    if (verificationStatus.icon) {
        return <Image src={verificationStatus.icon} alt={verificationStatus.value} className={style.image} />;
    }

    if (verificationStatus.value === TRU_NARRATIVE_VERIFICATION_STATUS.VERIFIED) {
        return <Icon className={style.icon} type="success" />;
    }

    return null;
};
